stateTransformer